module.exports = __webpack_public_path__ + "img/vue.6d5e8636.png";